(function() {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && window.theme.Shopify && window.theme.Shopify.formatMoney) {
      return window.theme.Shopify.formatMoney(cents, window.theme.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getOfferState(discountPct) {
    if (discountPct >= 100) return 'gwp';
    if (discountPct > 0)    return 'promo';
    return 'evergreen';
  }

  function addBothToCart(lampVariantId, shadeVariantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: parseInt(lampVariantId, 10), quantity: 1 },
          { id: parseInt(shadeVariantId, 10), quantity: 1 }
        ]
      })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart add failed: ' + res.status);
      return res.json();
    })
    .then(function(result) {
      document.dispatchEvent(new CustomEvent('cart:add', { detail: result }));
      return result;
    });
  }

  var ShadeOfferPDP = {
    container: null,
    header: null,
    body: null,
    shadeRow: null,
    summaryEl: null,
    atcButton: null,
    selectedShadeVariantId: null,
    selectedShadePrice: null,
    settings: null,

    init: function() {
      this.container = document.getElementById('shade-offer-pdp');
      if (!this.container) return;

      this.settings = window.shadeOfferSettings || {};
      if (!this.settings.enabled) return;

      this.header       = this.container.querySelector('.shade-offer-pdp__header');
      this.body         = this.container.querySelector('.shade-offer-pdp__body');
      this.shadeRow     = this.container.querySelector('.shade-offer-pdp__shade-row');
      this.summaryEl    = document.getElementById('shade-offer-pdp-summary');
      this.mobileColors = document.getElementById('shade-offer-pdp-mobile-colors');
      this.atcButton = document.getElementById('add-to-cart-btn');

      this._bindHeaderToggle();
      this._bindShadeSelection();
      this._bindAtcIntercept();
      this._watchVariantChange();

      var self = this;
      setTimeout(function() { self.open(); }, 800);
    },

    open: function() {
      this.container.setAttribute('aria-expanded', 'true');
      this.header.setAttribute('aria-expanded', 'true');
      this.body.removeAttribute('hidden');
    },

    close: function() {
      this.container.setAttribute('aria-expanded', 'false');
      this.header.setAttribute('aria-expanded', 'false');
      this.body.setAttribute('hidden', '');
    },

    _bindHeaderToggle: function() {
      var self = this;
      this.header.addEventListener('click', function() {
        var isOpen = self.container.getAttribute('aria-expanded') === 'true';
        if (isOpen) { self.close(); } else { self.open(); }
      });
      this.header.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          self.header.click();
        }
      });
    },

    _bindShadeSelection: function() {
      var self = this;

      this.shadeRow.addEventListener('click', function(e) {
        var dot  = e.target.closest('.shade-offer-pdp__shade-color');
        var card = e.target.closest('.shade-offer-pdp__shade-pick');

        if (dot) {
          e.stopPropagation();
          if (dot.classList.contains('sold-out')) return;
          var parentCard = dot.closest('.shade-offer-pdp__shade-pick');
          self._selectCard(parentCard);
          parentCard.querySelectorAll('.shade-offer-pdp__shade-color').forEach(function(d) {
            d.classList.remove('selected');
            d.setAttribute('aria-checked', 'false');
          });
          dot.classList.add('selected');
          dot.setAttribute('aria-checked', 'true');
          self.selectedShadeVariantId = dot.dataset.variantId;
          self.selectedShadePrice = parseInt(dot.dataset.variantPrice, 10);
          self._swapCardImage(parentCard, dot);
          self._updateSummary();
        } else if (card) {
          self._selectCard(card);
          var firstAvailableDot = card.querySelector('.shade-offer-pdp__shade-color:not(.sold-out)');
          if (firstAvailableDot) { firstAvailableDot.click(); }
        }
      });
    },

    _swapCardImage: function(card, dot) {
      var img = card.querySelector('img');
      if (img && dot.dataset.variantImage) {
        img.src = dot.dataset.variantImage;
        img.alt = dot.dataset.variantTitle || img.alt;
      }
    },

    _selectCard: function(card) {
      this.shadeRow.querySelectorAll('.shade-offer-pdp__shade-pick').forEach(function(c) {
        c.classList.remove('selected');
        c.setAttribute('aria-selected', 'false');
        if (c !== card) {
          c.querySelectorAll('.shade-offer-pdp__shade-color').forEach(function(d) {
            d.classList.remove('selected');
          });
        }
      });
      card.classList.add('selected');
      card.setAttribute('aria-selected', 'true');
      this._populateMobileColors(card);
    },

    _populateMobileColors: function(card) {
      if (!this.mobileColors) return;
      var self = this;
      var label = this.mobileColors.querySelector('.shade-offer-pdp__mobile-colors-label');
      var row = this.mobileColors.querySelector('.shade-offer-pdp__mobile-colors-row');
      var shadeName = card.dataset.shadeTitle || '';

      if (label) label.textContent = shadeName + ' color:';
      row.innerHTML = '';

      var dots = card.querySelectorAll('.shade-offer-pdp__shade-color');
      var firstAvailableIdx = -1;
      dots.forEach(function(dot, i) {
        var isSoldOut = dot.classList.contains('sold-out');
        if (!isSoldOut && firstAvailableIdx === -1) firstAvailableIdx = i;
        var btn = document.createElement('button');
        btn.className = 'shade-offer-pdp__mobile-color' + (isSoldOut ? ' sold-out' : '');
        btn.setAttribute('aria-label', dot.dataset.variantTitle || '');
        btn.dataset.variantId = dot.dataset.variantId;
        btn.dataset.variantPrice = dot.dataset.variantPrice;
        btn.dataset.variantTitle = dot.dataset.variantTitle;
        btn.innerHTML = '<span class="shade-offer-pdp__dot-fill" style="background: ' + getComputedStyle(dot.querySelector('.shade-offer-pdp__dot-fill')).backgroundColor + ';"></span>';
        if (isSoldOut) btn.disabled = true;
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          if (isSoldOut) return;
          row.querySelectorAll('.shade-offer-pdp__mobile-color').forEach(function(b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
          // Also update the hidden inline dot so the variant ID is in sync
          card.querySelectorAll('.shade-offer-pdp__shade-color').forEach(function(d) { d.classList.remove('selected'); });
          dot.classList.add('selected');
          self.selectedShadeVariantId = dot.dataset.variantId;
          self.selectedShadePrice = parseInt(dot.dataset.variantPrice, 10);
          self._swapCardImage(card, dot);
          self._updateSummary();
        });
        row.appendChild(btn);
      });

      this.mobileColors.removeAttribute('hidden');

      // Auto-select first available color on mobile
      if (firstAvailableIdx >= 0) {
        var mobileBtns = row.querySelectorAll('.shade-offer-pdp__mobile-color');
        if (mobileBtns[firstAvailableIdx]) {
          mobileBtns[firstAvailableIdx].classList.add('selected');
        }
        var firstDot = dots[firstAvailableIdx];
        firstDot.classList.add('selected');
        this.selectedShadeVariantId = firstDot.dataset.variantId;
        this.selectedShadePrice = parseInt(firstDot.dataset.variantPrice, 10);
        this._updateSummary();
      }
    },

    _updateSummary: function() {
      if (!this.summaryEl || !this.selectedShadeVariantId) return;

      var discountPct   = this.settings.discountPct || 0;
      var lampPrice     = this.settings.lampPrice || 0;
      var shadePrice    = this.selectedShadePrice || 0;
      var savings       = Math.round(shadePrice * discountPct / 100);
      var discounted    = shadePrice - savings;
      var newTotal      = lampPrice + discounted;
      var originalTotal = lampPrice + shadePrice;

      var hintEl  = this.summaryEl.querySelector('.shade-offer-pdp__summary-hint');
      var totalEl = this.summaryEl.querySelector('.shade-offer-pdp__summary-total');
      // Consume the single-sourced state emitted by Liquid (shadeOfferSettings.offerState);
      // fall back to deriving it only if absent (defensive). getOfferState stays as the
      // tested reference mapping — see tests/shade-offer.spec.js cross-check.
      var state   = this.settings.offerState || getOfferState(discountPct);

      if (state === 'gwp') {
        if (hintEl) hintEl.textContent = 'Free shade \u2014 you save ' + formatMoney(savings);
        if (totalEl) {
          totalEl.innerHTML = '<s class="shade-offer-pdp__was">' + formatMoney(originalTotal) + '</s> ' + formatMoney(newTotal);
        }
      } else if (state === 'promo') {
        if (hintEl) hintEl.textContent = discountPct + '% off shade \u2014 save ' + formatMoney(savings);
        if (totalEl) {
          totalEl.innerHTML = '<s class="shade-offer-pdp__was">' + formatMoney(originalTotal) + '</s> ' + formatMoney(newTotal);
        }
      } else {
        if (hintEl) hintEl.textContent = 'Shade: ' + formatMoney(shadePrice);
        if (totalEl) totalEl.textContent = formatMoney(newTotal);
      }

      if (this.atcButton) {
        this.atcButton.textContent = 'Add Both to Cart \u2014 ' + formatMoney(newTotal);
        this.atcButton.dataset.shadeVariantId = this.selectedShadeVariantId;
      }
    },

    _bindAtcIntercept: function() {
      var self = this;
      var form = document.querySelector('[data-product-form]');
      if (!form) return;

      form.addEventListener('submit', function(e) {
        if (!self.selectedShadeVariantId) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        var idInput = form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]');
        var lampVariantId = idInput ? idInput.value : self.settings.lampVariantId;

        var atcBtn = document.getElementById('add-to-cart-btn');
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Adding\u2026';
        }

        addBothToCart(lampVariantId, self.selectedShadeVariantId)
          .then(function() {
            self.selectedShadeVariantId = null;
            self.selectedShadePrice = null;
            if (self.shadeRow) {
              self.shadeRow.querySelectorAll('.shade-offer-pdp__shade-pick').forEach(function(c) {
                c.classList.remove('selected');
                c.setAttribute('aria-selected', 'false');
              });
            }
            if (self.summaryEl) {
              var hintEl = self.summaryEl.querySelector('.shade-offer-pdp__summary-hint');
              var totalEl = self.summaryEl.querySelector('.shade-offer-pdp__summary-total');
              if (hintEl) hintEl.textContent = 'Select a shade above';
              if (totalEl) totalEl.textContent = '';
            }
            if (atcBtn) {
              atcBtn.disabled = false;
              atcBtn.textContent = 'Add to Cart';
              delete atcBtn.dataset.shadeVariantId;
            }
          })
          .catch(function(err) {
            console.error('[ShadeOffer] Cart add failed:', err);
            if (atcBtn) {
              atcBtn.disabled = false;
              atcBtn.textContent = 'Add Both to Cart';
            }
          });
      }, true);
    },

    _watchVariantChange: function() {
      var self = this;
      var form = document.querySelector('[data-product-form]');
      if (!form) return;

      var select = form.querySelector('select[name="id"]');
      if (!select) return;

      select.addEventListener('change', function() {
        var productJsonEl = document.querySelector('[id^="cc-product-json-"]');
        if (!productJsonEl) return;

        try {
          var productData = JSON.parse(productJsonEl.textContent);
          var selectedVariant = productData.variants.find(function(v) {
            return v.id === parseInt(select.value, 10);
          });
          if (selectedVariant) {
            self.settings.lampPrice     = selectedVariant.price;
            self.settings.lampVariantId = selectedVariant.id;
          }
        } catch(e) { /* ignore */ }

        if (self.selectedShadeVariantId) {
          self._updateSummary();
          // Re-apply after a tick — theme.js may also update the button text on variant change
          setTimeout(function() { self._updateSummary(); }, 50);
        }
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { ShadeOfferPDP.init(); });
  } else {
    ShadeOfferPDP.init();
  }

  window.ShadeOffer = {
    addBothToCart: addBothToCart,
    getOfferState: getOfferState,
    formatMoney: formatMoney
  };

  // ─── Shades-only section: color dot selection + image swap ───

  document.addEventListener('click', function(e) {
    var dot = e.target.closest('.cordless-shades__color-dot');
    if (!dot) return;

    var card = dot.closest('.cordless-shades__card');
    if (!card) return;

    card.querySelectorAll('.cordless-shades__color-dot').forEach(function(d) {
      d.classList.remove('selected');
    });
    dot.classList.add('selected');

    var atcBtn = card.querySelector('.cordless-shades__atc');
    if (atcBtn) {
      atcBtn.dataset.variantId = dot.dataset.variantId;
    }

    if (dot.dataset.variantImage) {
      var img = card.querySelector('.cordless-shades__card-img');
      if (img) {
        img.src = dot.dataset.variantImage;
      }
    }

    if (dot.dataset.variantPrice) {
      var priceEl = card.querySelector('.cordless-shades__price');
      if (priceEl) {
        priceEl.textContent = formatMoney(parseInt(dot.dataset.variantPrice, 10));
      }
    }
  });

  // ─── Shades-only section: ATC button ───

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cordless-shades__atc');
    if (!btn) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart add failed: ' + res.status);
      return res.json();
    })
    .then(function(result) {
      document.dispatchEvent(new CustomEvent('cart:add', { detail: result }));
      btn.disabled = false;
      btn.textContent = 'Added';
      setTimeout(function() { btn.textContent = 'Add to Cart'; }, 2000);
    })
    .catch(function(err) {
      console.error('[ShadeOffer] Shade ATC failed:', err);
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
    });
  });

  // ─── Product grid shade hints ───

  (function() {
    if (!window.shadeHintConfig || !window.shadeHintConfig.enabled) return;

    var hintText = window.shadeHintConfig.hintText;
    var cordlessHandle = window.shadeHintConfig.cordlessHandle || 'cordless';

    function injectHints() {
      var cards = document.querySelectorAll('.product-block.cc-product-block');
      cards.forEach(function(card) {
        if (card.querySelector('.product-card__shade-hint')) return;

        var link = card.querySelector('a[href*="/products/"]');
        if (!link) return;

        var href = link.getAttribute('href') || '';
        var collectionMatch = href.indexOf('/collections/' + cordlessHandle + '/') !== -1;
        if (!collectionMatch) return;

        var caption = card.querySelector('.caption.upper');
        if (!caption) return;

        var hint = document.createElement('p');
        hint.className = 'product-card__shade-hint';
        hint.textContent = hintText;
        caption.appendChild(hint);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', injectHints);
    } else {
      injectHints();
    }

    document.addEventListener('cc:productgrid:updated', injectHints);
  })();

})();
